<template>
  <vue-tags-input v-model="tag"
                  :tags="tags"
                  :is-duplicate="isDuplicate"
                  :autocomplete-items="filteredItems"
                  @tags-changed="newTags => tags = newTags"
                  :placeholder="$t('Tags')" />
</template>

<script>
  import '../../plugins/vue-tags-input';
  import customerService from '../../services/customer';

  export default {
    name: 'CustomerTagsInput',
    props: {
      customerTags: {
        required: false,
        type: Array
      }
    },
    data() {
      return {
        tag: '',
        tags: [],
        tagList: []
      };
    },
    methods: {
      getTags() {
        customerService.getTags(this.tag).then(response => {
          this.tagList = response;
        });
      },
      isDuplicate() {
        if (this.tag) {
          return this.tags.map(t => t.text.toLowerCase()).indexOf(this.tag.toLowerCase()) !== -1;
        }
      }
    },
    watch: {
      tag: function () {
        if (this.tag != '') {
          this.getTags();
        }
      },
      tags: {
        handler: function () {
          this.$parent.$parent.$parent.$parent.model.customer_Tags = this.tags;
        },
        deep: true
      },
      customerTags: {
        handler: function () {
          this.tags = this.customerTags;
        },
        deep: true
      }
    },
    computed: {
      filteredItems() {
        return this.tagList.filter(i => {
          return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
        });
      }
    }
  };
</script>

<style>
  .vue-tags-input {
    max-width: 100% !important;
  }

  .vue-tags-input .ti-input {
    border-radius: 10px;
  }

  .vue-tags-input .ti-tag.ti-valid {
    background-color: #4cb0c5;
  }

  .ti-selected-item {
    background-color: #4cb0c5 !important;
  }
</style>
